import React, { useState } from 'react';
import styles from './News.module.css';
import { useTranslation } from 'react-i18next';
import pdf1 from '../../assets/files/Bitzer_FG_models.pdf';
import pdf2 from '../../assets/files/MAI_09_GSP6.pdf';
import pdf3 from '../../assets/files/Bitzer_0393-2025_15.pdf';
import pdf4 from '../../assets/files/LHV7E_4NE-14.FY.pdf';
import pdf5 from '../../assets/files/IQ CM RC 02.pdf';
import pdf6 from '../../assets/files/Поршневые компрессора Bitzer.pdf';
import telephone from '../../assets/images/telephone.png';
import emailIcon from '../../assets/images/email.png';

const newsData = [
  {
    title: 'Bitzer повідомляє про нові моделі',
    content: `Bitzer повідомляє, що з цього моменту сім нових моделей горизонтальних ресиверів F_G доступні для продажу.
  
      Серія "G" включає моделі зі збільшеними вхідними та вихідними з'єднаннями для холодоагенту порівняно зі стандартними ресиверами серій F і FS. Ця особливість є особливо корисною при використанні холодоагентів, чутливих до перепаду тиску.
      Окрім існуючих горизонтальних моделей F302G, F562G, F1052G та F1602G, ми представляємо сім нових моделей. Вперше у цій лінійці з’явилися ресивери з діаметром корпусу 500 мм.`,
    pdfLink: pdf1,
    footer: 'Нижче наведено перелік нових моделей F_G',
  },
  {
    title: 'Серійний випуск для GSP60120 ...GSP60235 для застосувань 50 ГЦ',
    content: `Зверніть увагу, що серія ORBIT PRO 6 (GSP60120 ... GSP60235) тепер повністю доступна для застосування з частотою 50 Гц у серійному виробництві.
              Серія ORBIT PRO спеціально розроблена для R290 у системах кондиціонування повітря,теплових насосах та технологічному охолодженні та нагріванні.`,
    pdfLink: pdf2,
    footer: 'Нижче більш детальніше',
  },
  {
    title: 'Наявність у продажу комплектів BITZER PERFORMANCE KITS',
    content: `Ми раді повідомити про наявність комплектів PERFORMANCE KITS для оновлення встановленої бази поршневих компресорів серії BITZER ECOLINE (HFC/HFO) та ECOLINE PRO.`,
    pdfLink: pdf3,
    footer: 'Нижче більш детальніше',
  },
  {
    title: 'Припинення виробництва продукту ECOSTAR LHV7E/4NE-14.FY',
    content: `Ми повідомляємо, що у зв'язку з припиненням виробництва постачальником компонента,що використовується в ECOSTAR LHV7E/4NE-14.FY, лише цей конкретний пристрій сімейства ECOSTAR буде поступово виведено з виробництва. Станом на 15 жовтня 2025 року на складі залишилося 22 одиниці. Ці пристрої будуть розподілені в порядку черги після отримання замовлення. Для більших замовлень, будь
ласка, перевіряйте наявність заздалегідь. повідомити про наявність комплектів PERFORMANCE KITS для оновлення встановленої бази поршневих компресорів серії BITZER ECOLINE (HFC/HFO) та ECOLINE PRO.`,
    pdfLink: pdf4,
    footer: 'Нижче більш детальніше',
  },
  {
    title: 'Новий індивідуальний пароль для модуля IQ CMRC-02',
    content: `З серпня 2025 року діє Директива ЄС щодо радіообладнання (RED 2014/53/EU). Тому всі електронні вироби з можливістю радіозв'язку та IP-стеком повинні відповідати новому стандарту кібербезпеки. В результаті пароль для продуктів BITZER IQ зміниться з 4-значного пароля на новий індивідуальний пароль з 8 до 14 цифр.`,
    pdfLink: pdf5,
    footer: 'Нижче більш детальніше',
  },
  {
    title: 'Напівгерметичні поршневі компресори Bitzer',
    content: ` `,
    pdfLink: pdf6,
    footer: 'Нижче більш детальніше',
  },
];

const News = () => {
  const { t } = useTranslation('translation');
  const [openIndex, setOpenIndex] = useState(null);

  const toggleNews = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="news" className={styles.newsSection}>
      <div className={styles.container}>
        <div className={styles.contacts}>
          <div className={styles.contactItem}>
            <img src={telephone} loading="lazy" alt="Телефон" className={styles.icon} />
            <a href="tel:+380443565620" className={styles.contactLink}>
              +38 (044) 356 56 20
            </a>
          </div>
          <div className={styles.contactItem}>
            <img src={telephone} loading="lazy" alt="Телефон" className={styles.icon} />
            <a href="tel:+380443565630" className={styles.contactLink}>
              +38 (044) 356 56 30
            </a>
          </div>
          <div className={styles.contactItem}>
            <img src={telephone} loading="lazy" alt="Телефон" className={styles.icon} />
            <a href="tel:+380676502036" className={styles.contactLink}>
              +38 (067) 650 20 36
            </a>
          </div>
          <div className={styles.contactItem}>
            <img src={emailIcon} loading="lazy" alt="email" className={styles.icon} />
            <a href="mailto:info@domus.biz.ua" className={styles.contactLink}>
              info@domus.biz.ua
            </a>
          </div>
        </div>
        <h2 className={styles.title}>{t('news.title')}</h2>
        <ul className={styles.newsList}>
          {newsData.map((news, index) => (
            <li key={index} className={styles.newsItem}>
              <button
                className={styles.newsTitle}
                onClick={() => toggleNews(index)}
              >
                {news.title}
              </button>
              {openIndex === index && (
                <div className={styles.newsContent}>
                  <p>{news.content}</p>
                  <strong>{news.footer}</strong>
                  <br />
                  <a
                    href={news.pdfLink}
                    download
                    className={styles.downloadButton}
                  >
                    Завантажити
                  </a>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default News;
